<script setup lang="ts">
import { Lock, ShieldCheck, UserCheck } from 'lucide-vue-next'
</script>

<template>
  <section class="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6">
    <h4 class="font-semibold text-gray-900 mb-4 text-sm">Trusted & Secure</h4>
    <div class="space-y-4">
      <div class="flex items-center space-x-3">
        <div class="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm">
          <Lock class="w-5 h-5 text-green-600" />
        </div>
        <div>
          <p class="font-medium text-gray-900 text-sm">256-bit SSL</p>
          <p class="text-xs text-gray-600">Bank-level encryption</p>
        </div>
      </div>
      <div class="flex items-center space-x-3">
        <div class="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm">
          <svg class="w-6 h-6 text-purple-600" viewBox="0 0 32 32" fill="currentColor">
            <path d="M16 4c-4.4 0-8 1.8-8 4v2.5c0 2.2 3.6 4 8 4s8-1.8 8-4V8c0-2.2-3.6-4-8-4zm6 6.5c0 .8-2.7 2-6 2s-6-1.2-6-2V9.8c1.5.7 3.6 1.2 6 1.2s4.5-.5 6-1.2v.7zm-6 5.5c-4.4 0-8-1.8-8-4v2c0 2.2 3.6 4 8 4s8-1.8 8-4v-2c0 2.2-3.6 4-8 4zm0 4c-4.4 0-8-1.8-8-4v2c0 2.2 3.6 4 8 4s8-1.8 8-4v-2c0 2.2-3.6 4-8 4zm0 4c-4.4 0-8-1.8-8-4v2c0 2.2 3.6 4 8 4s8-1.8 8-4v-2c0 2.2-3.6 4-8 4z"/>
          </svg>
        </div>
        <div>
          <p class="font-medium text-gray-900 text-sm">Powered by Stripe</p>
          <p class="text-xs text-gray-600">Secure payment processing</p>
        </div>
      </div>
      <div class="flex items-center space-x-3">
        <div class="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm">
          <UserCheck class="w-5 h-5 text-blue-600" />
        </div>
        <div>
          <p class="font-medium text-gray-900 text-sm">PCI Compliant</p>
          <p class="text-xs text-gray-600">Industry standard security</p>
        </div>
      </div>
    </div>
  </section>
</template>
